import { ReactElement, useCallback } from "react";
import { ListItem } from "../ListItem";
import { RssItemModel } from "client/Api/Workspace/LiveInformation/Rss/rssLiveInformation";
import { DateString, PipeSeparator } from "client/Components";
import { sanitizeUriForReact } from "client_legacy/ndaw/urlHelper";
import styles from "./RssListItem.module.less";
import { navigateTo } from "client_legacy/ndaw/navigator";
import { isNil } from "client/Misc/utils";
import { TimeZone } from "client/DateAndTime/timezones";

export type RssListItemProps = {
	isCompactView: boolean;
	item: RssItemModel;
	timezone: TimeZone;
	onClick(): void;
};

export const RssListItem = (props: RssListItemProps): ReactElement => {
	const {
		isCompactView,
		item,
		timezone,
		onClick
	} = props;

	const navigateHandler = useCallback(
		(): void => {
			onClick();

			if (!item.url) {
				return;
			}

			const urlEndpoint: string | undefined = sanitizeUriForReact(item.url);
			if (isNil(urlEndpoint)) {
				throw new Error("item url is null");
			}

			navigateTo(urlEndpoint, true);

		},
		[onClick, item.url]
	);

	return(
		<ListItem
			onClick={navigateHandler}
			isHoverable
			isWide={!isCompactView}
			title={item.title}
		>
			{!isCompactView && item.imageUrl && (
				<ListItem.Icon>
					<div className={styles.thumbnailContainer}>
						<img
							src={item.imageUrl}
							alt={item.title}
							className={styles.imagePreview}
						/>
					</div>
				</ListItem.Icon>
			)}
			<ListItem.Content>
				<ListItem.Row>
					<ListItem.Title>
						{item.title}
					</ListItem.Title>
				</ListItem.Row>
				<ListItem.Row>
					<ListItem.Info>
						<DateString
							value={item.publishDate}
							format="AbsoluteTimestamp"
							timezone={timezone}
						/>
						{item.category && (
							<>
								<PipeSeparator />
								{item.category}
							</>
						)}
					</ListItem.Info>
				</ListItem.Row>
				{!isCompactView && (
					<ListItem.Row>
						<ListItem.Description>
							{item.description}
						</ListItem.Description>
					</ListItem.Row>
				)}
			</ListItem.Content>
		</ListItem>
	);
};
RssListItem.displayName = "RssListItem";